var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84375 5.1875C9.84375 4.92862 10.0536 4.71875 10.3125 4.71875H12.8076C12.995 4.71875 13.1781 4.77489 13.3332 4.87994C13.4884 4.98498 13.6085 5.13411 13.6781 5.30807L13.2429 5.48216L13.6781 5.30807L14.4977 7.35716C14.5555 7.50158 14.5379 7.66525 14.4507 7.79404C14.3635 7.92284 14.218 8 14.0625 8H10.3125C10.0536 8 9.84375 7.79013 9.84375 7.53125V5.1875ZM10.7813 5.65625V7.0625H13.3701L12.8076 5.65625H10.7813Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.46875 8.9375C0.46875 8.67862 0.678617 8.46875 0.9375 8.46875H10.3125C10.5714 8.46875 10.7812 8.67862 10.7812 8.9375C10.7812 9.19638 10.5714 9.40625 10.3125 9.40625H0.9375C0.678617 9.40625 0.46875 9.19638 0.46875 8.9375Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0156 10.8125C10.4979 10.8125 10.0781 11.2322 10.0781 11.75C10.0781 12.2678 10.4979 12.6875 11.0156 12.6875C11.5334 12.6875 11.9531 12.2678 11.9531 11.75C11.9531 11.2322 11.5334 10.8125 11.0156 10.8125ZM9.14062 11.75C9.14062 10.7145 9.98009 9.875 11.0156 9.875C12.0512 9.875 12.8906 10.7145 12.8906 11.75C12.8906 12.7855 12.0512 13.625 11.0156 13.625C9.98009 13.625 9.14062 12.7855 9.14062 11.75Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.98438 10.8125C3.46661 10.8125 3.04688 11.2322 3.04688 11.75C3.04688 12.2678 3.46661 12.6875 3.98438 12.6875C4.50214 12.6875 4.92188 12.2678 4.92188 11.75C4.92188 11.2322 4.50214 10.8125 3.98438 10.8125ZM2.10938 11.75C2.10938 10.7145 2.94884 9.875 3.98438 9.875C5.01991 9.875 5.85938 10.7145 5.85938 11.75C5.85938 12.7855 5.01991 13.625 3.98438 13.625C2.94884 13.625 2.10938 12.7855 2.10938 11.75Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92188 11.75C4.92188 11.4911 5.13174 11.2812 5.39062 11.2812H9.60938C9.86826 11.2812 10.0781 11.4911 10.0781 11.75C10.0781 12.0089 9.86826 12.2188 9.60938 12.2188H5.39062C5.13174 12.2188 4.92188 12.0089 4.92188 11.75Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.743337 4.05584C0.919153 3.88002 1.15761 3.78125 1.40625 3.78125H10.3125C10.5714 3.78125 10.7812 3.99112 10.7812 4.25V10.5321C10.7812 10.791 10.5714 11.0009 10.3125 11.0009C10.0536 11.0009 9.84375 10.791 9.84375 10.5321V4.71875L1.40625 4.71875V11.2812H2.57812C2.83701 11.2812 3.04688 11.4911 3.04688 11.75C3.04688 12.0089 2.83701 12.2188 2.57812 12.2188H1.40625C1.15761 12.2188 0.919153 12.12 0.743337 11.9442C0.567522 11.7683 0.46875 11.5299 0.46875 11.2812V4.71875C0.46875 4.47011 0.567522 4.23165 0.743337 4.05584Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84375 7.53125C9.84375 7.27237 10.0536 7.0625 10.3125 7.0625H14.0625C14.3214 7.0625 14.5312 7.27237 14.5312 7.53125V11.2812C14.5312 11.5299 14.4325 11.7683 14.2567 11.9442C14.0808 12.12 13.8424 12.2188 13.5938 12.2188H12.4219C12.163 12.2188 11.9531 12.0089 11.9531 11.75C11.9531 11.4911 12.163 11.2812 12.4219 11.2812H13.5938V8H10.7812V10.5321C10.7812 10.791 10.5714 11.0009 10.3125 11.0009C10.0536 11.0009 9.84375 10.791 9.84375 10.5321V7.53125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/vehicle.5c0f65a9d6585dcdd3db6839c271ab58.svg";
export { ForwardRef as ReactComponent };